export default "/images/9d0b2f74ea5cc692dffb22fc90cd5c5b.avif";